import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Form, FormGroup, Label} from 'reactstrap';
import trainingPhasesSelectors from '../../../store/training-phases/selectors';
import {Storage} from "../../../../shared/services/aws";
import './AttachmentForm.scss';

class AttachmentForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      state: 'initial'
    }
  }

  // ----------------------
  // Methods
  // ----------------------

  handleSubmit(event) {
    event.preventDefault();
  }
  uploadFile(event) {
    const file = event.target.files[0];
    const reportGuid = this.props.addingAttachmentFor;
    const s3Key = `${this.props.userContext.departmentGuid}/reports/${reportGuid}/${file.name}`;

    this.setState({
      state: 'uploading'
    });

    Storage.put(s3Key, file, {
      contentType: file.type, partSize: 1024 * 1024 * 10,
      progressCallback: (progress) => {
        this.setState({
          progress: ((progress.loaded/progress.total) * 100).toFixed(0)
        })
        console.log(`Uploaded: ${progress.loaded}/${progress.total}`);
      }
    })
      .then((result) => {
        const formData = {
          filename: file.name,
          s3Key: result.key,
          reportGuid,
        };
        this.props.onUpload(formData);
      })
      .catch((error) => {
        console.log(`[AttachmentForm] uploadFile() error: ${JSON.stringify(error)}`);
      });

  }

  render() {
    return (
      <Fragment>
        { this.state.state === 'initial'
          ? <Form
              className="m-3"
              noValidate
              onSubmit={event => this.handleSubmit(event)}
            >
              <FormGroup>
                <Label for="title">
                  File Upload <i className="fa fa-asterisk"/>
                </Label>
                <input type="file" onChange={event => this.uploadFile(event)}/>
              </FormGroup>
            </Form>
          : null
        }
        { this.state.state === 'uploading'
          ? (
            <div className="attachment-form-upload">
              <div className="upload-progress">
                  <div className="progress-bar" style={{
                    transform: `translateX(-${100 - this.state.progress}%)`
                  }}/>
              </div>
              <div className="percent">{this.state.progress}%</div>
            </div>
          )
          : null
        }
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    addingAttachmentFor: state.attachments.addingAttachmentFor,
    report: trainingPhasesSelectors.editingReport(state),
    scheduledReport: trainingPhasesSelectors.addingScheduledReport(state),
    userContext: state.common.userContext,
  };
};

export default connect(mapStateToProps)(AttachmentForm);
